import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Button } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useDownloadFile } from "../../../../hooks/useDownloadFile";
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';

const useStyles = makeStyles((theme) => ({
  listBox: {
    maxWidth: 600,
    margin: '0 auto',
    marginBottom: 30
  },
  listTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    marginBottom: 6
  },
  fileContainer: {
    border: `solid 1px ${theme.palette.grey[300]}`,
    padding: theme.spacing(3),
    borderRadius: 6,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 120,
  },
  stepQuestion: {
    display: 'flex',
    justifyContent: 'center',
    '& button': {
      minWidth: 140,
      color: theme.palette.common.gamsDarkBlue,
      borderColor: theme.palette.common.gamsDarkBlue,
      '&:hover': {
        backgroundColor: theme.palette.common.blue[600],
        color: theme.palette.common.white,
      },
      '&:focus': {
        outline: 'none',
      },
      '&:active': {
        backgroundColor: theme.palette.common.blue[600],
        color: theme.palette.common.white,
      },
    },
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
}));

const ResultFileAnswers = ({ answers, documentPath }) => {
  const classes = useStyles();
  const downloadFileMutation = useDownloadFile();
  const handleDownloadFile = async () => {
    if (documentPath) {
      try {
        // Estrae il nome del file dall'URL o usa un nome di default
        const blob = await downloadFileMutation.mutateAsync({ url: documentPath });
        const fileName = documentPath.split('/').pop() || 'downloaded-file';
        
        // Crea un link temporaneo e forza il download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        
        // Pulisce
        document.body.removeChild(link);
        
      } catch (error) {
        console.error('Error downloading file:', error);
        // Fallback: apri il file in una nuova finestra
        window.open(documentPath, '_blank', 'noopener,noreferrer');
      }
    } else {
      console.warn('No document path provided for download');
    }
  };

  return (
    <Box className={classes.listBox}>
      <Typography className={classes.listTitle} component="h3">Your Answers</Typography>
      <div className={classes.fileContainer}>
        <div className={classes.stepQuestion}>
          <Box className={classes.buttonsContainer}>
            { downloadFileMutation.isPending && <LoadingSpinner /> }
            { !downloadFileMutation.isPending &&
            <Button 
              variant="outlined"
              onClick={handleDownloadFile}
              startIcon={<GetAppIcon />}
              disabled={!documentPath}
            >
              Download File
            </Button>}
          </Box>
        </div>
      </div>
    </Box>
  );
};

export default ResultFileAnswers;
